import React, { useRef } from 'react';
import clsx from 'clsx';

export interface OtpInputProps {
    value: string;
    onChange: (value: string) => void;
    length?: number;
    disabled?: boolean;
    autoFocus?: boolean;
    className?: string;
}

/** Six 52×60 cells (68px tall on lg) driven by one hidden numeric input. */
export const OtpInput: React.FC<OtpInputProps> = ({ value, onChange, length = 6, disabled, autoFocus, className }) => {
    const ref = useRef<HTMLInputElement>(null);
    const digits = value.replace(/\D/g, '').slice(0, length);
    const focusIdx = Math.min(digits.length, length - 1);

    return (
        <div className={clsx('relative', className)} onClick={() => ref.current?.focus()}>
            <input
                ref={ref}
                value={digits}
                onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, length))}
                inputMode="numeric"
                autoComplete="one-time-code"
                maxLength={length}
                disabled={disabled}
                autoFocus={autoFocus}
                aria-label="OTP"
                className="absolute inset-0 w-full h-full opacity-0 cursor-default"
            />
            <div className="grid gap-2 lg:gap-2.5 pointer-events-none" style={{ gridTemplateColumns: `repeat(${length}, minmax(0, 1fr))` }}>
                {Array.from({ length }).map((_, i) => {
                    const ch = digits[i];
                    const focused = i === focusIdx && digits.length < length;
                    return (
                        <div
                            key={i}
                            className={clsx(
                                'flex h-[60px] lg:h-[68px] items-center justify-center rounded-md text-[26px] lg:text-[30px] font-black tnum',
                                ch
                                    ? 'bg-surface-card border border-line'
                                    : focused
                                        ? 'bg-surface-card border-2 border-accent-500 shadow-focus'
                                        : 'bg-surface-sunken border border-line-subtle',
                            )}
                        >
                            {ch ?? (focused && <span className="w-0.5 h-[26px] bg-accent-500 animate-pulse" />)}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
export default OtpInput;
